
export default {
  persistKeys: ['tabs']
}
